import React from 'react';
import { motion } from 'framer-motion';
const WHATSAPP_LINK = 'https://wa.me/573054520211?text=Hola%20vengo%20desde%20la%20web%20y%20quiero%20reservar%20una%20cita';
export function HeroSection() {
  return <section className="relative md:min-h-screen bg-brand-black overflow-hidden" data-id="element-49">
      {/* DESKTOP: full background image */}
      <div className="hidden md:block absolute inset-0 z-0" style={{
      perspective: '1200px'
    }} data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        rotateX: 8,
        scale: 1.1
      }} animate={{
        opacity: 1,
        rotateX: 0,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: 'easeOut'
      }} className="absolute inset-0" style={{
        transformStyle: 'preserve-3d'
      }} data-id="element-51">
          <img src="https://cdn.magicpatterns.com/uploads/pJdw3H9fDmjut4U28EYJ6A/ChatGPT_Image_30_mar_2026,_12_09_08.png" alt="Le Barber Club" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-52" />
        </motion.div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-transparent to-transparent" data-id="element-53" />
      </div>

      {/* MOBILE: image flows naturally, no gap */}
      <div className="md:hidden flex flex-col" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        scale: 1.05
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="relative pt-16" data-id="element-55">
          <img src="https://cdn.magicpatterns.com/uploads/pJdw3H9fDmjut4U28EYJ6A/ChatGPT_Image_30_mar_2026,_12_09_08.png" alt="Le Barber Club" className="w-full h-auto" data-id="element-56" />
          {/* Gradient that blends image into content below */}
          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-brand-black to-transparent" data-id="element-57" />
        </motion.div>

        {/* Mobile content directly after image */}
        <div className="px-4 -mt-8 relative z-10 flex flex-col items-center text-center pb-10" data-id="element-58">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="text-4xl font-bold text-white mb-4 leading-tight" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.7), 0 0 40px rgba(0,0,0,0.4)'
        }} data-id="element-59">
            Corte premium en Sabaneta sin esperas
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5,
          ease: 'easeOut'
        }} className="text-lg text-brand-light/80 mb-8 max-w-sm" data-id="element-60">
            Reserva tu cita en menos de 30 segundos
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7,
          ease: 'easeOut'
        }} className="flex flex-col items-center gap-4 w-full" data-id="element-61">
            <motion.a whileTap={{
            scale: 0.95
          }} href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="w-full btn-gold px-8 py-4 text-lg flex items-center justify-center gap-2" data-id="element-62">
              <span className="text-xl" data-id="element-63">📲</span> Reservar cita por WhatsApp
            </motion.a>

            <motion.a whileTap={{
            scale: 0.95
          }} href="#servicios" className="w-full btn-outline-gold px-8 py-4 text-lg flex items-center justify-center gap-2" data-id="element-64">
              👉 Ver servicios
            </motion.a>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.9,
          ease: 'easeOut'
        }} className="text-sm text-brand-gray/70 mt-6 max-w-xs italic" data-id="element-65">
            Estilo, precisión y actitud. En Le Barber Club transformamos tu look
            en una experiencia premium
          </motion.p>
        </div>
      </div>

      {/* DESKTOP content */}
      <div className="hidden md:flex relative z-10 min-h-screen items-end justify-center pb-28" data-id="element-66">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-67">
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} className="text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.7), 0 0 40px rgba(0,0,0,0.4)'
        }} data-id="element-68">
            Corte premium en Sabaneta sin esperas
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6,
          ease: 'easeOut'
        }} className="text-2xl text-brand-light/80 mb-10 max-w-2xl" data-id="element-69">
            Reserva tu cita en menos de 30 segundos
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.8,
          ease: 'easeOut'
        }} className="flex flex-row items-center gap-4" data-id="element-70">
            <motion.a whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="btn-gold px-8 py-4 text-lg flex items-center justify-center gap-2" data-id="element-71">
              <span className="text-xl" data-id="element-72">📲</span> Reservar cita por WhatsApp
            </motion.a>

            <motion.a whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} href="#servicios" className="btn-outline-gold px-8 py-4 text-lg flex items-center justify-center gap-2" data-id="element-73">
              👉 Ver servicios
            </motion.a>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 1,
          ease: 'easeOut'
        }} className="text-base text-brand-gray/70 mt-8 max-w-xl italic" data-id="element-74">
            Estilo, precisión y actitud. En Le Barber Club transformamos tu look
            en una experiencia premium
          </motion.p>
        </div>
      </div>

      {/* Decorative bottom line */}
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-brand-gold/50 to-transparent z-10" data-id="element-75"></div>
    </section>;
}